import { CompanyMember } from "@/models/company/company-member";
import { apiService } from "@/services/apiService";
import { endpoints } from "@/config/endpoints";

export class CompanyService {
  static getMembers({ companyId, page, perPage }) {
    const params = { page, page_size: perPage };
    return apiService
      .get(endpoints.companyMembers(companyId), {
        params
      })
      .then(res => {
        if (res && res.data && res.data.results) {
          res.data.results = res.data.results.map(
            item => new CompanyMember(item)
          );
        }
        return res;
      });
  }

  static getMember(memberId, companyId) {
    return apiService
      .get(endpoints.companyMembers(companyId) + memberId + "/")
      .then(res => {
        if (res && res.data) {
          return {
            ...res,
            data: new CompanyMember(res.data)
          };
        }

        return res;
      });
  }

  static saveMember(member, companyId) {
    return apiService
      .post(endpoints.companyMembers(companyId), member)
      .then(res => {
        if (res && res.data) {
          return {
            ...res,
            data: new CompanyMember(res.data)
          };
        }

        return res;
      });
  }

  static updateMember(memberId, member, companyId) {
    return apiService
      .put(endpoints.companyMembers(companyId) + memberId + "/", member)
      .then(res => {
        if (res && res.data) {
          return {
            ...res,
            data: new CompanyMember(res.data)
          };
        }

        return res;
      });
  }

  static deleteMember(memberId, companyId) {
    return apiService.delete(
      endpoints.companyMembers(companyId) + memberId + "/"
    );
  }
}
